var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 5.51281C6.4 6.00614 6.3 6.45281 6.1 6.85281C5.9 7.24614 5.59333 7.55947 5.18 7.79281C4.77333 8.01947 4.25333 8.13281 3.62 8.13281C2.73333 8.13281 2.05667 7.89281 1.59 7.41281C1.13 6.92614 0.9 6.28614 0.9 5.49281V0.892806H1.8V5.52281C1.8 6.10281 1.95333 6.55281 2.26 6.87281C2.57333 7.19281 3.04333 7.35281 3.67 7.35281C4.10333 7.35281 4.45333 7.27614 4.72 7.12281C4.99333 6.96281 5.19333 6.74614 5.32 6.47281C5.44667 6.19281 5.51 5.87281 5.51 5.51281V0.892806H6.4V5.51281Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.28281H7.31V9.78281H0V9.28281Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/UnderlineIcon.3599b8dc8061dc4865c2672c4bdad97d.svg";
export { ForwardRef as ReactComponent };